import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
  inputLabel: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px !important',
    paddingLeft: '10px',
  },
  inputLabelText: {
    fontFamily: 'Montserrat',
    fontSize: 10,
    position: 'absolute',
    top: '100%',
  },
  menuItem: {
    fontFamily: 'Montserrat',
    fontSize: 14,
  },
  listItemText: {
    fontFamily: 'Montserrat',
    fontSize: 14,
  },
}))
